import script from "./tabbers.vue?vue&type=script&setup=true&lang=js"
export * from "./tabbers.vue?vue&type=script&setup=true&lang=js"

import "./tabbers.vue?vue&type=style&index=0&id=20807614&lang=css"

const __exports__ = script;

export default __exports__